import type React from "react";

import { faArrowRightToLine, faMessages } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

const SIDE_PANEL_WIDTH = "400px";

interface Props {
  isOpen: boolean;
  inMaximisedCall: boolean;
  onClick: () => void;
}

export const ConversationToggleButton: React.FC<Props> = ({ isOpen, inMaximisedCall, onClick }) => (
  <Wrapper $isSidePanelOpen={isOpen} $inMaximisedCall={inMaximisedCall}>
    <Button onClick={onClick}>
      <FontAwesomeIcon size="xl" icon={isOpen ? faArrowRightToLine : faMessages} />
    </Button>
  </Wrapper>
);

const Wrapper = styled.div<{ $isSidePanelOpen: boolean; $inMaximisedCall: boolean }>`
  display: none;
  pointer-events: none;
  @media screen and (min-width: 1300px) {
    display: block;
    position: fixed;
    right: ${({ $isSidePanelOpen, $inMaximisedCall, theme }) => {
      if ($isSidePanelOpen) return `calc(${SIDE_PANEL_WIDTH} + 20px)`;
      if ($inMaximisedCall) return `calc(${theme.videoCallWidthMaximised}px + 20px)`;
      return "20px";
    }};
    bottom: 15px;
    z-index: ${({ theme }) => theme.zIndex.header};
    transition: right 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  }
`;

const Button = styled.button`
  pointer-events: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 48px;
  height: 48px;
  border: none;
  box-shadow: 1px 2px 12px 2px rgba(23, 34, 47, 0.15);
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.redesign.b30};
  color: ${({ theme }) => theme.colors.redesign.b100};
  transition: 0.2s;

  &:hover {
    background: ${({ theme }) => theme.colors.redesign.b10};
    color: ${({ theme }) => theme.colors.redesign.b100};
  }
`;
